import request from '@/utils/request';

const BASE_URL = '/api';

const getUserStatus = (data) => request({
  url: BASE_URL + '/advertisement/userStatus',
  method: 'post',
  data,
});

const getPublicize = (data) => request({
  url: BASE_URL + '/publicize/getPublicize',
  method: 'post',
  data,
});

const getUploadClickAction = (data) => request({
  url: BASE_URL + '/publicize/uploadClick',
  method: 'post',
  data,
});

export {
  getUserStatus, getPublicize, getUploadClickAction,
};
